export interface Video {
  id: string;
  title: string;
  categorySlug: string;
  thumbnail: string;
  duration: string;
  views: number;
  rating: number;
  description: string;
  isNew: boolean;
  isHot: boolean;
}

export const videos: Video[] = [
  {
    id: 'v001',
    title: '暖暖爱 第一集：初遇的心动',
    categorySlug: 'aiqing-ju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Warm%20romantic%20Chinese%20drama%20scene%20with%20soft%20natural%20lighting%2C%20two%20people%20meeting%20in%20a%20cozy%20cafe%2C%20warm%20amber%20and%20rose%20tones%2C%20cinematic%20composition%2C%20emotional%20atmosphere%2C%20soft%20focus%20background%2C%20beautiful%20aesthetic&width=640&height=360&seq=video-thumb-001&orientation=landscape',
    duration: '45:20',
    views: 1280000,
    rating: 9.5,
    description: '一段温暖的邂逅，开启了属于他们的故事。在这座繁华都市的角落，两个人的命运悄然交织。',
    isNew: false,
    isHot: true,
  },
  {
    id: 'v002',
    title: '暖暖爱 第二集：靠近的心跳',
    categorySlug: 'aiqing-ju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20drama%20couple%20walking%20in%20autumn%20park%2C%20golden%20hour%20lighting%2C%20warm%20rose%20and%20gold%20tones%2C%20cinematic%20depth%20of%20field%2C%20emotional%20connection%2C%20soft%20bokeh%20background%2C%20beautiful%20composition&width=640&height=360&seq=video-thumb-002&orientation=landscape',
    duration: '42:15',
    views: 1150000,
    rating: 9.3,
    description: '随着相处的加深，两颗心越靠越近。那些不经意的小动作，都是爱的暗示。',
    isNew: false,
    isHot: true,
  },
  {
    id: 'v003',
    title: '暖暖爱 第三集：甜蜜的考验',
    categorySlug: 'aiqing-ju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Emotional%20Chinese%20romance%20drama%20scene%2C%20couple%20facing%20challenges%20together%2C%20warm%20interior%20lighting%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20cinematic%20mood%2C%20intimate%20atmosphere%2C%20beautiful%20aesthetic&width=640&height=360&seq=video-thumb-003&orientation=landscape',
    duration: '48:30',
    views: 980000,
    rating: 9.4,
    description: '爱情的路上并非一帆风顺，但正是这些考验，让他们的感情更加坚定。',
    isNew: true,
    isHot: true,
  },
  {
    id: 'v004',
    title: '暖暖爱 第四集：重逢的拥抱',
    categorySlug: 'aiqing-ju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Touching%20reunion%20scene%20in%20Chinese%20romance%20drama%2C%20warm%20sunset%20backlighting%2C%20emotional%20embrace%2C%20soft%20golden%20and%20rose%20tones%2C%20cinematic%20wide%20shot%2C%20beautiful%20atmospheric%20composition&width=640&height=360&seq=video-thumb-004&orientation=landscape',
    duration: '50:10',
    views: 890000,
    rating: 9.6,
    description: '分别后的重逢总是格外动人。时间没有冲淡感情，反而让思念愈加深厚。',
    isNew: true,
    isHot: false,
  },
  {
    id: 'v005',
    title: '暖暖爱 第五集：永恒的誓言',
    categorySlug: 'aiqing-ju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Romantic%20wedding%20proposal%20scene%20in%20Chinese%20drama%2C%20warm%20candlelight%20atmosphere%2C%20soft%20rose%20petals%2C%20intimate%20moment%2C%20cinematic%20close-up%2C%20beautiful%20warm%20lighting%2C%20emotional%20composition&width=640&height=360&seq=video-thumb-005&orientation=landscape',
    duration: '55:00',
    views: 1050000,
    rating: 9.7,
    description: '在满天星空下许下的诺言，将两颗心永远绑在一起。这是属于他们的浪漫结局。',
    isNew: false,
    isHot: true,
  },
  {
    id: 'v006',
    title: '都市恋歌：职场风云录',
    categorySlug: 'dushi-ju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20office%20drama%20scene%2C%20professional%20workplace%20setting%2C%20warm%20natural%20lighting%20through%20large%20windows%2C%20clean%20aesthetic%2C%20soft%20beige%20and%20cream%20tones%2C%20cinematic%20composition&width=640&height=360&seq=video-thumb-006&orientation=landscape',
    duration: '40:25',
    views: 760000,
    rating: 9.1,
    description: '在竞争激烈的职场中，她用智慧和坚韧走出了一条属于自己的路。',
    isNew: false,
    isHot: false,
  },
  {
    id: 'v007',
    title: '城市之光：创业者的梦想',
    categorySlug: 'dushi-ju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20urban%20drama%20startup%20office%20scene%2C%20young%20entrepreneurs%20working%20together%2C%20modern%20co-working%20space%2C%20warm%20amber%20lighting%2C%20inspirational%20atmosphere%2C%20cinematic%20composition&width=640&height=360&seq=video-thumb-007&orientation=landscape',
    duration: '38:50',
    views: 620000,
    rating: 8.9,
    description: '梦想从不嫌晚。几个年轻人怀揣理想，在城市中书写着属于自己的创业传奇。',
    isNew: true,
    isHot: false,
  },
  {
    id: 'v008',
    title: '长安风华：盛唐遗梦',
    categorySlug: 'guzhuang-ju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20historical%20costume%20drama%20scene%2C%20ancient%20palace%20garden%20setting%2C%20elegant%20Tang%20dynasty%20aesthetic%2C%20warm%20golden%20sunlight%2C%20soft%20silk%20fabrics%2C%20cinematic%20composition%2C%20ethereal%20atmosphere&width=640&height=360&seq=video-thumb-008&orientation=landscape',
    duration: '52:30',
    views: 1350000,
    rating: 9.8,
    description: '穿越千年的爱恋，在大唐盛世的背景下展开一段荡气回肠的故事。',
    isNew: false,
    isHot: true,
  },
  {
    id: 'v009',
    title: '锦绣未央：宫廷心计',
    categorySlug: 'guzhuang-ju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20palace%20drama%20interior%20scene%2C%20ornate%20ancient%20Chinese%20architecture%2C%20elegant%20court%20ladies%2C%20warm%20candlelight%20ambiance%2C%20rich%20red%20and%20gold%20decor%2C%20cinematic%20lighting%2C%20dramatic%20composition&width=640&height=360&seq=video-thumb-009&orientation=landscape',
    duration: '56:40',
    views: 1420000,
    rating: 9.6,
    description: '后宫深处的权力博弈，每一个微笑背后都暗藏玄机。她能否在这深宫中保全自己？',
    isNew: false,
    isHot: true,
  },
  {
    id: 'v010',
    title: '迷雾追踪：消失的证据',
    categorySlug: 'xuanyi-ju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Suspenseful%20Chinese%20crime%20drama%20scene%2C%20dimly%20lit%20investigation%20room%2C%20moody%20atmosphere%2C%20warm%20desk%20lamp%20lighting%2C%20detective%20working%20late%2C%20cinematic%20noir%20style%2C%20tense%20composition&width=640&height=360&seq=video-thumb-010&orientation=landscape',
    duration: '44:15',
    views: 870000,
    rating: 9.2,
    description: '一桩离奇的案件，所有的证据都指向不可能。真相究竟是什么？',
    isNew: true,
    isHot: false,
  },
  {
    id: 'v011',
    title: '暗夜追凶：连环谜案',
    categorySlug: 'xuanyi-ju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Mystery%20Chinese%20drama%20night%20scene%2C%20rainy%20urban%20street%2C%20detective%20silhouette%2C%20moody%20warm%20streetlamp%20lighting%2C%20atmospheric%20fog%2C%20cinematic%20thriller%20aesthetic%2C%20tense%20composition&width=640&height=360&seq=video-thumb-011&orientation=landscape',
    duration: '46:50',
    views: 790000,
    rating: 9.0,
    description: '夜幕降临，罪恶浮现。一位执着的刑警，在层层迷雾中追寻真相。',
    isNew: false,
    isHot: false,
  },
  {
    id: 'v012',
    title: '温馨小窝：北欧风改造',
    categorySlug: 'jiaju-ju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cozy%20Scandinavian%20style%20living%20room%20interior%2C%20warm%20natural%20lighting%2C%20minimalist%20furniture%2C%20soft%20beige%20and%20cream%20tones%2C%20indoor%20plants%2C%20hygge%20atmosphere%2C%20beautiful%20home%20decor%20composition&width=640&height=360&seq=video-thumb-012&orientation=landscape',
    duration: '28:30',
    views: 450000,
    rating: 8.8,
    description: '用最温暖的色调改造旧居，打造一个充满幸福感的北欧风温馨小窝。',
    isNew: false,
    isHot: false,
  },
  {
    id: 'v013',
    title: '家的味道：外婆的厨房',
    categorySlug: 'meishi-ju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Warm%20Chinese%20home%20kitchen%20cooking%20scene%2C%20steaming%20homemade%20food%2C%20golden%20warm%20lighting%2C%20traditional%20Chinese%20cooking%2C%20cozy%20family%20atmosphere%2C%20beautiful%20food%20photography%20composition&width=640&height=360&seq=video-thumb-013&orientation=landscape',
    duration: '32:15',
    views: 680000,
    rating: 9.3,
    description: '回到外婆的厨房，熟悉的香味唤起了最温暖的童年记忆。每一道菜都是爱的味道。',
    isNew: false,
    isHot: true,
  },
  {
    id: 'v014',
    title: '舌尖之旅：云南美食记',
    categorySlug: 'meishi-ju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20Yunnan%20cuisine%20food%20photography%2C%20colorful%20local%20dishes%20on%20wooden%20table%2C%20warm%20natural%20lighting%2C%20fresh%20ingredients%2C%20rustic%20aesthetic%2C%20appetizing%20composition&width=640&height=360&seq=video-thumb-014&orientation=landscape',
    duration: '35:40',
    views: 720000,
    rating: 9.4,
    description: '走进云南，探寻那些藏在山水间的美味。从过桥米线到野生菌火锅，一场味蕾的盛宴。',
    isNew: true,
    isHot: false,
  },
  {
    id: 'v015',
    title: '大理慢时光：洱海边的日子',
    categorySlug: 'lvxing-ju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20Dali%20Erhai%20Lake%20landscape%2C%20golden%20sunset%20over%20water%2C%20Cangshan%20mountains%20background%2C%20warm%20atmospheric%20lighting%2C%20peaceful%20travel%20scene%2C%20cinematic%20wide%20composition&width=640&height=360&seq=video-thumb-015&orientation=landscape',
    duration: '30:20',
    views: 560000,
    rating: 9.1,
    description: '在大理的日子很慢，慢到可以看尽洱海的每一次日落，听遍苍山的每一缕风声。',
    isNew: false,
    isHot: false,
  },
  {
    id: 'v016',
    title: '宝宝的第一年：成长日记',
    categorySlug: 'qinzi-ju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Heartwarming%20Chinese%20family%20scene%20with%20baby%2C%20soft%20natural%20window%20lighting%2C%20gentle%20parenting%20moment%2C%20warm%20cream%20and%20beige%20tones%2C%20cozy%20home%20atmosphere%2C%20beautiful%20emotional%20composition&width=640&height=360&seq=video-thumb-016&orientation=landscape',
    duration: '26:50',
    views: 380000,
    rating: 9.5,
    description: '记录宝宝成长的第一年，每一个第一次都是最珍贵的回忆。',
    isNew: true,
    isHot: false,
  },
];